<div class="container-fluid">

  <rbb-side-menu-headline
    description="Hier können alle Daten in rbb Forms durchsucht werden."
    headline="Explorer"
    icon="fa-solid fa-folder-tree"/>

  <div class="row">
    <div class="col-2 border-end">
      <rbb-tree [treeItem]="treeItem" [enableSearch]="true" foldedIcon="fa-solid fa-caret-right" unfoldedIcon="fa-solid fa-caret-down" itemIcon="fa-solid fa-user" [(ngModel)]="selectedItem" (ngModelChange)="getEmployee()"/>
    </div>

    <div class="col-10">
      @if (selectedItem && selectedItem.orgUnit) {
        <div class="row">
          <h4>{{selectedItem.orgUnit}}</h4>
          <div class="col-6 mb-3">
            <span class="fw-bold">Abteilung / Bereich</span>
            <hr class="m-0 mb-2 p-0">
            <div class="row">
              <div class="col-12 mt-4">
                <label class="d-block small text-darkgray fw-bold">Organisationseinheit</label>
                {{selectedItem.orgUnit}} <br>
              </div>
              @if (selectedItem.department) {
                <div class="col-12 mt-4">
                  <label class="d-block small text-darkgray fw-bold">Abteilung (bzw. erste Organisationseinheit unter der Hauptabteilung)</label>
                  {{selectedItem.department}}
                </div>
              }
              @if (selectedItem.mainDepartment) {
                <div class="col-12 mt-4">
                  <label class="d-block small text-darkgray fw-bold">Hauptabteilung (bzw. erste Organisationseinheit unter der Direktion)</label>
                  {{selectedItem.mainDepartment}}
                </div>
              }
              @if (selectedItem.directorate) {
                <div class="col-12 mt-4">
                  <label class="d-block small text-darkgray fw-bold">Direktion (bzw. höchste Genehmigungsebene in rbb Forms)</label>
                  {{selectedItem.directorate}}
                </div>
              }
            </div>
          </div>
          <div class="col-6 mb-3">
            <span class="fw-bold">Vorgesetzte</span>
            <hr class="m-0 p-0">
            <div class="row">
              @if (selectedItem.chiefUsername) {
                <div class="col-12 mt-2">
                  <label class="d-block small text-darkgray fw-bold">Vorgesetzte/r</label>
                  {{selectedItem.chiefFirstName}} {{selectedItem.chiefLastName}}<br>
                  @if (selectedItem.deputyChiefUsername) {
                    {{selectedItem.deputyChiefFirstName}} {{selectedItem.deputyChiefLastName}} <small>(Stellvertretung)</small>
                  } @else {
                    <small>keine Stellvertretung gepflegt</small>
                  }
                </div>
              }
              @if (selectedItem.departmentUsername) {
                <div class="col-12 mt-4">
                  <label class="d-block small text-darkgray fw-bold">Abteilungsleiter/in</label>
                  {{selectedItem.departmentFirstName}} {{selectedItem.departmentLastName}}<br>
                  @if (selectedItem.deputyDepartmentUsername) {
                    {{selectedItem.deputyDepartmentFirstName}} {{selectedItem.deputyDepartmentLastName}} <small>(Stellvertretung)</small>
                  } @else {
                    <small>keine Stellvertretung gepflegt</small>
                  }
                </div>
              }
              @if (selectedItem.mainDepartmentUsername) {
                <div class="col-12 mt-4">
                  <label class="d-block small text-darkgray fw-bold">HA Leiter/in</label>
                  {{selectedItem.mainDepartmentFirstName}} {{selectedItem.mainDepartmentLastName}}<br>
                  @if (selectedItem.mainDepartmentUsername) {
                    {{selectedItem.deputyMainDepartmentFirstName}} {{selectedItem.deputyMainDepartmentLastName}} <small>(Stellvertretung)</small>
                  } @else {
                    <small>keine Stellvertretung gepflegt</small>
                  }
                </div>
              }
              @if (selectedItem.directorUsername) {
                <div class="col-12 mt-4">
                  <label class="d-block small text-darkgray fw-bold">Direktor/in</label>
                  {{selectedItem.directorFirstName}} {{selectedItem.directorLastName}}<br>
                  @if (selectedItem.deputyDirectorUsername) {
                    {{selectedItem.deputyDirectorFirstName}} {{selectedItem.deputyDirectorLastName}} <small>(Stellvertretung)</small>
                  } @else {
                    <small>keine Stellvertretung gepflegt</small>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      }
      @if (selectedItem?.name && employee) {
        <div class="row">
          <div class="col-12 col-lg-6 mb-3">
            <span class="fw-bold">Person</span>
            <hr class="m-0 p-0">
            <div class="row">
              <div class="col-12 mt-2">
                <label class="d-block small text-darkgray fw-bold">Name</label>
                {{employee.firstName}} {{employee.lastName}}
              </div>
              <div class="col-12 mt-4">
                <label class="d-block small text-darkgray fw-bold">Benutzername</label>
                {{employee.username}}
              </div>
              <div class="col-12 mt-4">
                <label class="d-block small text-darkgray fw-bold">UID des Benutzerkontos</label>
                {{employee.uidNumber}}
              </div>
              <div class="col-12 mt-4">
                <label class="d-block small text-darkgray fw-bold">E-Mail</label>
                {{employee.emailAddress}}
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 mb-3">
            <span class="fw-bold">Vertrag</span>
            <hr class="m-0 p-0">
            <div class="row">
              <div class="col-12 mt-2">
                <label class="d-block small text-darkgray fw-bold">Personalnummer</label>
                {{employee.employeeNumber}}
              </div>
              <div class="col-12 mt-4">
                <label class="d-block small text-darkgray fw-bold">Kostenstelle</label>
                {{employee.costCentre}}
              </div>
              <div class="col-12 mt-4">
                <label class="d-block small text-darkgray fw-bold">Vertragstyp</label>
                @switch (employee.employeeType) {
                  @case (EmployeeType.PERMANENT) { Fest }
                  @case (EmployeeType.FREELANCER) { Frei }
                  @case (EmployeeType.TEMPORARY) { Aushilfe }
                  @case (EmployeeType.EXTERNAL) { Extern }
                  @default { Unbekannt }
                }
              </div>
              <div class="col-12 mt-4">
                <label class="d-block small text-darkgray fw-bold">Vereinbarung zum mobilen Arbeiten</label>
                {{employee.mobileWorkAgreement ?? 'keine'}}
              </div>
              <div class="col-12 mt-4">
                <label class="d-block small text-darkgray fw-bold">Schwerbehinderung</label>
                {{employee.disabilityStatus ? 'Ja' : 'Nein'}}
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 mb-3">
            <span class="fw-bold">Abteilung / Bereich</span>
            <hr class="m-0 mb-2 p-0">
            <div class="row">
              <div class="col-12 mt-4">
                <label class="d-block small text-darkgray fw-bold">Organisationseinheit</label>
                {{employee.orgUnit}} <br>
              </div>
              @if (employee.department) {
                <div class="col-12 mt-4">
                  <label class="d-block small text-darkgray fw-bold">Abteilung (bzw. erste Organisationseinheit unter der Hauptabteilung)</label>
                  {{employee.department}}
                </div>
              }
              @if (employee.mainDepartment) {
                <div class="col-12 mt-4">
                  <label class="d-block small text-darkgray fw-bold">Hauptabteilung (bzw. erste Organisationseinheit unter der Direktion)</label>
                  {{employee.mainDepartment}}
                </div>
              }
              @if (employee.directorate) {
                <div class="col-12 mt-4">
                  <label class="d-block small text-darkgray fw-bold">Direktion</label>
                  {{employee.directorate}}
                </div>
              }
            </div>
          </div>
          <div class="col-12 col-lg-6 mb-3">
            <span class="fw-bold">Vorgesetzte</span>
            <hr class="m-0 p-0">
            <div class="row">
              @if (employee.chiefUsername) {
                <div class="col-12 mt-2">
                  <label class="d-block small text-darkgray fw-bold">Vorgesetzte/r</label>
                  {{employee.chiefFirstName}} {{employee.chiefLastName}}<br>
                  @if (employee.deputyChiefUsername) {
                    {{employee.deputyChiefFirstName}} {{employee.deputyChiefLastName}} <small>(Stellvertretung)</small>
                  } @else {
                    <small>keine Stellvertretung gepflegt</small>
                  }
                </div>
              }
              @if (employee.departmentUsername) {
                <div class="col-12 mt-4">
                  <label class="d-block small text-darkgray fw-bold">Abteilungsleiter/in</label>
                  {{employee.departmentFirstName}} {{employee.departmentLastName}}<br>
                  @if (employee.deputyDepartmentUsername) {
                    {{employee.deputyDepartmentFirstName}} {{employee.deputyDepartmentLastName}} <small>(Stellvertretung)</small>
                  } @else {
                    <small>keine Stellvertretung gepflegt</small>
                  }
                </div>
              }
              @if (employee.mainDepartmentUsername) {
                <div class="col-12 mt-4">
                  <label class="d-block small text-darkgray fw-bold">HA Leiter/in</label>
                  {{employee.mainDepartmentFirstName}} {{employee.mainDepartmentLastName}}<br>
                  @if (employee.mainDepartmentUsername) {
                    {{employee.deputyMainDepartmentFirstName}} {{employee.deputyMainDepartmentLastName}} <small>(Stellvertretung)</small>
                  } @else {
                    <small>keine Stellvertretung gepflegt</small>
                  }
                </div>
              }
              @if (employee.directorUsername) {
                <div class="col-12 mt-4">
                  <label class="d-block small text-darkgray fw-bold">Direktor/in</label>
                  {{employee.directorFirstName}} {{employee.directorLastName}}<br>
                  @if (employee.deputyDirectorUsername) {
                    {{employee.deputyDirectorFirstName}} {{employee.deputyDirectorLastName}} <small>(Stellvertretung)</small>
                  } @else {
                    <small>keine Stellvertretung gepflegt</small>
                  }
                </div>
              }
            </div>
          </div>
          <div class="col-12">
            @if (!processes) {
              <rbb-loader/>
            } @else {
              <app-processes-table [processes]="processes"/>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
